import { FcNext } from 'react-icons/fc';
import { BiBuildings } from 'react-icons/bi';
import './MatchedCitiesList.css';

const MatchedCitiesList = ({ cities, cityChangeHandler }) => (
    <div className="results__items">
        {cities.map((city, index) => {
            if (index >= 10) return null;

            return (
                <button className="results__item" key={city.name} onClick={() => cityChangeHandler(city)}>
                    <div className="results__column-left">
                        <div className="results__icon"><BiBuildings /></div>
                        <div className="results__location">
                            <div className="results__city">{city.name}</div> 
                            <div className="results__province">{city.province}</div>
                        </div>
                    </div>
                    <div className="results__icon results__arrow"><FcNext /></div>
                </button>
            )
        })}
    </div>
)

export default MatchedCitiesList;
